// extracted by mini-css-extract-plugin
export var root = "MarkdownFigure-module--root--06541";